// ABOUTME: Resolves the browser Supabase url/anon key for the active project (primary "prod" or DR standby) from VITE_ACTIVE_SUPABASE.
// ABOUTME: Falls back to the canonical VITE_SUPABASE_* when the flag is unset. Static member access so Vite inlines every value at build time.

interface BrowserSupabaseConfig {
  url: string;
  anonKey: string;
}

// Each set is read via static import.meta.env.VITE_* access so Vite inlines it
// at build time — computed keys (import.meta.env[`VITE_${x}`]) are NOT inlined.
const PROD = {
  url: import.meta.env.VITE_PROD_SUPABASE_URL as string | undefined,
  anonKey: import.meta.env.VITE_PROD_SUPABASE_ANON_KEY as string | undefined,
};
const STANDBY = {
  url: import.meta.env.VITE_STANDBY_SUPABASE_URL as string | undefined,
  anonKey: import.meta.env.VITE_STANDBY_SUPABASE_ANON_KEY as string | undefined,
};
const CANONICAL = {
  url: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined,
};

function validate(
  set: { url?: string; anonKey?: string },
  source: string,
): BrowserSupabaseConfig {
  if (!set.url || !set.anonKey) {
    throw new Error(
      `Missing Supabase config (${source}): set the URL and anon key at build time.`,
    );
  }
  return { url: set.url, anonKey: set.anonKey };
}

export function resolveActiveSupabase(): BrowserSupabaseConfig {
  const active = (import.meta.env.VITE_ACTIVE_SUPABASE as string | undefined)
    ?.trim()
    .toLowerCase();
  if (active === "prod") return validate(PROD, "VITE_PROD_SUPABASE_*");
  if (active === "standby") return validate(STANDBY, "VITE_STANDBY_SUPABASE_*");
  if (active) {
    throw new Error(
      `VITE_ACTIVE_SUPABASE must be "prod" or "standby", got "${active}".`,
    );
  }
  return validate(CANONICAL, "VITE_SUPABASE_*");
}
